import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stripHtmlTags } from "@msys/common";
import { Box, Card, CardActionArea, CardContent, CardMedia, Stack, Typography, useTheme, } from "@mui/material";
import React from "react";
import { GalleryModal } from "./gallery/GalleryModal.js";
import { useScreenWidth } from "./hooks/useScreenWidth.js";
import { ModalOpenProcess, } from "./modal/ModalOpenProcess.js";
import defaultImageUrl from "../assets/no-image.png";
import { ellipsisStyle } from "./text/Ellipsis.js";
import { TypographyWithMaxNumberOfLines } from "./text/Typography.js";
export const MediaListItem = ({ ActionButton, StatusIcons, Info, Tags, title, description, article, brand, price, imageUrl = defaultImageUrl, onClick, style, size: sizeProp, descriptionMaxNumberOfLines, images, selected = false, ...props }) => {
    const { isMinTablet } = useScreenWidth();
    const theme = useTheme();
    const size = sizeProp ?? (isMinTablet ? "medium" : "small");
    const processRef = React.useRef();
    return (_jsxs(Card, { ...props, sx: {
            display: "flex",
            position: "relative",
            minHeight: theme.layout.imageSize.sm,
            textDecoration: "none",
            flexShrink: 0,
            flexGrow: 0,
            ...(selected
                ? {
                    borderWidth: 1,
                    borderColor: "secondary.main",
                }
                : undefined),
            ...props.sx,
        }, style: {
            minHeight: size !== "medium"
                ? theme.layout.imageSize.sm
                : theme.layout.imageSize.lg,
            ...(style ?? {}),
        }, children: [_jsx(CardMedia, { sx: {
                    flexGrow: 0,
                    flexShrink: 0,
                    alignSelf: "stretch",
                    cursor: (images && images.length > 0) || onClick ? "pointer" : "default",
                    // aspectRatio: "1 / 1", // Not supported on Safari < 15 https://caniuse.com/mdn-css_properties_aspect-ratio
                }, image: imageUrl, style: {
                    minHeight: size === "medium"
                        ? theme.layout.imageSize.lg
                        : theme.layout.imageSize.sm,
                    paddingLeft: size !== "medium"
                        ? theme.layout.imageSize.sm
                        : theme.layout.imageSize.lg,
                }, onClick: images && images.length > 0
                    ? e => {
                        e.preventDefault();
                        e.stopPropagation();
                        processRef.current?.open();
                    }
                    : onClick }), _jsx(CardActionArea, { onClick: onClick, disableRipple: true, sx: { minWidth: 0 }, children: _jsxs(CardContent, { sx: {
                        padding: 1,
                        minHeight: "100%",
                        minWidth: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                    }, style: {
                        marginLeft: size === "medium" ? 4 : 0,
                        marginRight: size === "medium" ? 4 : 0,
                    }, children: [_jsxs(Stack, { direction: "row", spacing: 1, justifyContent: "space-between", alignItems: "flex-start", children: [_jsxs(Stack, { direction: "column", spacing: 0.25, style: ellipsisStyle, children: [brand && (_jsx(Typography, { variant: "body2", fontWeight: "bold", children: brand })), _jsx(Typography, { variant: size === "medium" ? "h3" : "h4", noWrap: true, children: title })] }), ActionButton || (StatusIcons && StatusIcons.length > 0) ? (_jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", flexShrink: 0, flexGrow: 0, height: 20, pt: 0.5, onMouseDown: e => {
                                        e.stopPropagation();
                                    }, onTouchStart: e => {
                                        e.stopPropagation();
                                    }, onClick: e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }, children: [StatusIcons, ActionButton] })) : null] }), _jsxs(Stack, { direction: "row", spacing: size === "medium" ? 2 : 1, justifyContent: "space-between", flexGrow: 1, children: [_jsxs(Stack, { direction: "column", flex: 1, spacing: 0.25, style: ellipsisStyle, children: [_jsx(TypographyWithMaxNumberOfLines, { "$maxLines": descriptionMaxNumberOfLines ?? (size === "medium" ? 2 : 1), variant: "body2", children: description ? stripHtmlTags(description, true) : null }), article && (_jsx(Typography, { variant: "body2", sx: { color: "grey.600" }, noWrap: true, children: article })), Info ? _jsx(Box, { children: Info }) : null, Tags ? _jsx(Box, { children: Tags }) : null] }), price ? (_jsx(Box, { alignSelf: "flex-end", flexShrink: 0, flexGrow: 0, children: _jsx(Typography, { variant: "body1", children: price }) })) : null] })] }) }), images && (_jsx(ModalOpenProcess, { ref: processRef, Modal: GalleryModal, modalProps: {
                    images,
                } })), selected && (_jsx(Box, { sx: {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    userSelect: "none",
                    pointerEvents: "none",
                    outline: 2,
                    outlineColor: "secondary.main",
                    outlineOffset: -1,
                } }))] }));
};
//# sourceMappingURL=MediaListItem.js.map